<template>
  <a-modal
    title="指定批次"
    :visible="visible"
    :width="1040"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="batch-title">
      <p class="goods-name">货品名称：{{goodData.skuName}}</p>
      <p>货品编码：{{goodData.skuCode}}</p>
    </div>
    <a-table
      :columns="batchTableColumns"
      :data-source="dataList"
      class="table-sigle"
      :row-key="(record, index) => record.batchNo + index"
      :pagination="false"
      :scroll="{ x: 'calc(700px + 50%)', y: '40vh'}"
      :row-selection="{
        onSelect,
        onSelectAll,
        onChange,
        selectedRowKeys: selectedRowKeys,
      }"
    />
  </a-modal>
</template>

<script>
import { batchTableColumns } from '../goodsTable'
import { getStockPage } from '../api'

export default {
  name: 'SpecifyBatch',
  data() {
    return {
      visible: false,
      goodData: {},
      chooseIndex: null,
      batchTableColumns,
      dataList: [],
      selectedRows: [],
      selectedRowKeys: [],
    }
  },
  methods: {
    remove(record) {
      this.selectedRows = this.selectedRows.filter((e) => {
        return e.id !== record.id
      })
    },
    onSelect(record, selected) {
      if (selected) {
        this.selectedRows.push(record)
      } else {
        this.remove(record)
      }
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        this.selectedRows.push(...changeRows)
      } else {
        changeRows.forEach((e) => {
          this.remove(e)
        })
      }
    },
    onChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    async getStockPage(code) {
      const res = await getStockPage({
        goodsCode: this.goodData.skuCode,
        warehouseCode: code
      }, {
        size: 999,
        page: 1,
      })
      this.dataList = res.records
    },
    show(index, row, code) {
      this.visible = true
      this.goodData = row
      this.chooseIndex = index
      this.selectedRows = []
      this.selectedRowKeys = []
      this.getStockPage(code)
    },
    handleOk() {
      this.visible = false
      this.$emit('chooseBatch', this.selectedRows, this.goodData.skuCode, this.chooseIndex)
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.batch-title {
  color: #323232;
  display: flex;
  margin-bottom: 32px;
  .goods-name {
    margin-right: 120px;
  }
}
</style>
